export default __webpack_public_path__ + "static/media/menu-02.02a56b26.png";